export default replace;

function replace(s) {
    return s.replace(/\.[^/.]+$/, '');
}
